import { render } from "./AnalyticsNumPracticeComparative.vue?vue&type=template&id=8ab9274a&scoped=true"
import script from "./AnalyticsNumPracticeComparative.vue?vue&type=script&lang=js"
export * from "./AnalyticsNumPracticeComparative.vue?vue&type=script&lang=js"

import "@/css/components/analytics-num-practice-comparative.css?vue&type=style&index=0&id=8ab9274a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ab9274a"]])

export default __exports__